import type { Inline } from "../lib/release-notes";

/** Renders the inline runs the notes and guide parsers produce: code, bold, italics, links, text. */
export function Inlines({ parts }: { parts: Inline[] }) {
  return (
    <>
      {parts.map((p, i) => {
        switch (p.kind) {
          case "code":
            return <code key={i} className="rounded bg-neutral-100 px-1 font-mono text-[0.85em] dark:bg-neutral-800">{p.text}</code>;
          case "strong":
            return <strong key={i}>{p.text}</strong>;
          case "em":
            return <em key={i}>{p.text}</em>;
          case "link":
            return <a key={i} href={p.href} className="text-accent-strong underline dark:text-accent" target="_blank" rel="noreferrer">{p.text}</a>;
          default:
            return <span key={i}>{p.text}</span>;
        }
      })}
    </>
  );
}
